import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_10863_32420)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M100.25 22.75C100.25 21.2312 99.0188 20 97.5 20H22.5C20.9812 20 19.75 21.2312 19.75 22.75V97.75C19.75 99.2688 20.9812 100.5 22.5 100.5H97.5C99.0188 100.5 100.25 99.2688 100.25 97.75V22.75ZM102.25 97.75C102.25 100.373 100.123 102.5 97.5 102.5H22.5C19.8766 102.5 17.75 100.373 17.75 97.75V22.75C17.75 20.1266 19.8766 18 22.5 18H97.5C100.123 18 102.25 20.1266 102.25 22.75V97.75Z",
				fill: "#14151F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M81.5 26.25V11.25C81.5 10.6977 81.9477 10.25 82.5 10.25C83.0523 10.25 83.5 10.6977 83.5 11.25V26.25C83.5 26.8023 83.0523 27.25 82.5 27.25C81.9477 27.25 81.5 26.8023 81.5 26.25Z",
				fill: "#14151F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36.5 26.25V11.25C36.5 10.6977 36.9477 10.25 37.5 10.25C38.0523 10.25 38.5 10.6977 38.5 11.25V26.25C38.5 26.8023 38.0523 27.25 37.5 27.25C36.9477 27.25 36.5 26.8023 36.5 26.25Z",
				fill: "#14151F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M101.25 40.25C101.802 40.25 102.25 40.6977 102.25 41.25C102.25 41.8023 101.802 42.25 101.25 42.25H18.75C18.1977 42.25 17.75 41.8023 17.75 41.25C17.75 40.6977 18.1977 40.25 18.75 40.25H101.25Z",
				fill: "#14151F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M67.2917 70.6216C67.2917 66.4794 63.9339 63.1216 59.7917 63.1216C55.6496 63.1216 52.2917 66.4794 52.2917 70.6216C52.2917 74.7637 55.6496 78.1216 59.7917 78.1216C63.9339 78.1216 67.2917 74.7637 67.2917 70.6216ZM69.2917 70.6216C69.2917 75.8683 65.0385 80.1216 59.7917 80.1216C54.545 80.1216 50.2917 75.8683 50.2917 70.6216C50.2917 65.3749 54.545 61.1216 59.7917 61.1216C65.0385 61.1216 69.2917 65.3749 69.2917 70.6216Z",
				fill: "url(#paint0_linear_10863_32420)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_10863_32420",
		x1: 50.2917,
		y1: 80.1216,
		x2: 72.6746,
		y2: 74.4336,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#E45D96"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_10863_32420",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 120,
			height: 120,
			fill: "white"
		})
	})] })]
});
export default SvgCalendarBig;
